import Client from './client';

export default class FinancialReportingStatements extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  getByStatementNumber(statementNumber, options = {}) {
    return this.makeRequest(`${this.host}/internal/financial_reporting_statement/${statementNumber}`, options);
  }

  postByStatementNumber(statementNumber, options = {}) {
    return this.makeRequest(`${this.host}/internal/financial_reporting_statement/${statementNumber}`, {
      ...options,
       method: 'POST',
    });
  }

}
